export default __webpack_public_path__ + "static/biography-55b5791b464b900088cfa8a472e86147.jpg";